import React from "react";
import { ProducerRevenueLoaderTemplate } from "themes/application/producer/components";

function ProducerRevenueLoader(props) {
    return <ProducerRevenueLoaderTemplate {...props} />;
}

export default ProducerRevenueLoader;
